import React, {useContext, useRef, useEffect, useState} from 'react';

// import CountDown from 'components/CountDown';
import VideoPlayer from 'components/VideoPlayer';
import Context from 'utils/Context';
import Conf from 'utils/Conf';

import './Multiplex.scss';

function getStatus(countdown) {
  if (countdown > 15000) {
    return 'waiting';
  }
  if (countdown >= 0) {
    return 'playing-countdown';
  }
  return 'live';
}

const Screen = ({evenement, countdown, salleRef}) => {
  const {appState, methods} = useContext(Context);
  const [introStatus, setStatus] = useState(getStatus(countdown));
  const introPlayer = useRef(null);

  const handleIntroEnd = () => {
    if (introStatus === 'playing-countdown') {
      setStatus('playing-logo');
      return;
    }
    if (introStatus === 'playing-logo') {
      setStatus('live');
    }
  };

  useEffect(() => {
    if (introStatus === 'playing-countdown') {
      // Imperative intro playing
      introPlayer.current.play();
    } else if (introStatus === 'playing-logo') {
      // Imperative intro playing
      introPlayer.current.src = `${Conf.assetsRoot}/25eh.mp4`;
      introPlayer.current.play();
    }
  }, [introStatus]);

  useEffect(() => {
    if (introStatus !== 'waiting') return;
    const status = getStatus(countdown);
    setStatus(status);
  }, [countdown, introStatus]);

  return (
    <div className="multiplex-screen">
      {introStatus === 'live' && (
        <VideoPlayer
          video={evenement.live_id}
          paused={false}
          autoplay={true}
          // onPlay={this.handlePlay}
          // onPause={this.handlePause}
          node={salleRef.current}
          // onShowControls={this.handleShowControls}
          // onHideControls={this.handleHideControls}
          isLive
          // {...this.props}
          appState={appState}
          methods={methods}
        />
      )}
      {introStatus !== 'live' && (
        <div className="seance-players show">
          <div className="video-player-container">
            <video
              className="multiplex-video-player-intro"
              onEnded={handleIntroEnd}
              ref={introPlayer}
              playsInline
              src={`${Conf.assetsRoot}/countdown.mp4`}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default Screen;
